import { NgxSliderModule } from "ngx-slider-v2";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { MAT_RIPPLE_GLOBAL_OPTIONS } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy, RouterModule } from "@angular/router";
import { UiLibraryModule } from "@caballus/ui-library";
import { StorageService } from "@ion-caballus/core/services";
import { InitAction, states } from "@ion-caballus/core/state";
import { environment } from "@ion-caballus/env";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { NgxsEmitPluginModule } from "@ngxs-labs/emitter";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { NgxsModule, Store } from "@ngxs/store";
import { RfxFormsModule } from "@rfx/ngx-forms";
import { RFX_HTTP_HOST_URL, RfxHttpModule, UrlInterceptor } from "@rfx/ngx-http";
import { ToastrService } from "ngx-toastr";
import { ToastrModule } from "ngx-toastr";
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { AuthGuard } from "./core/routes/guards";
import { LoginResolver } from "./core/routes/resolver";

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        IonicModule.forRoot(),
        CommonModule,
        CoreModule,
        UiLibraryModule,
        NgxsModule.forRoot(states, { developmentMode: !environment.production }),
        NgxsEmitPluginModule.forRoot(),
        NgxsReduxDevtoolsPluginModule.forRoot({
            disabled: environment.production
        }),
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        RfxHttpModule,
        RfxFormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        NgxSliderModule,
        RouterModule.forRoot(
            [
                {
                    path: 'auth',
                    loadChildren: (): any => import('./auth/auth.module').then(m => m.AuthModule),
                    resolve: [
                        LoginResolver
                    ]
                },
                {
                    path: 'tabs',
                    canActivate: [AuthGuard],
                    loadChildren: (): any =>
                        import('./tabs/tabs.module').then(m => m.TabsModule)
                },
                {
                    path: '**',
                    redirectTo: '/auth/login'
                }
            ],
            { initialNavigation: 'enabledBlocking' }
        )
    ],
    providers: [
        ToastrService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UrlInterceptor,
            multi: true
        },
        {
            provide: RFX_HTTP_HOST_URL,
            useValue: environment.webserver
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (storageService: StorageService, store: Store) =>
                async () => {
                    await storageService.init();
                    await store.dispatch(new InitAction()).toPromise();
                },
            deps: [StorageService, Store],
            multi: true
        },
        {provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {disabled: true}}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
